/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock my-1 font-semibold cursor-pointer-simulation" v-for="i in controls" :key="i">{{i}}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-1/2 flex items-center">
                  <h2 class="font-bold">Use-Case Scenario</h2>
                </div>
                <div class="vx-col w-1/2 flex items-center">
                  <h2 class="font-bold">Cloud Deployment Model</h2>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">Large multinational organizations wanting to improve elasticity and resource usage of hardware that is housing on-premise critical internal services</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="input0">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">Collection of organizations in the same industry vertical developing services based on a common application stack</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="input1">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">Organization that has an orchestration bus that integrates with a large on-premise footprint, subscribing to a small amount of external software services and starting to move workloads to a variety of other cloud models</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="input2">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">Marketing organization that outsources email delivery to an online provider</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="input3">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">Organization that has migrated their highly customized external websites into the cloud</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="input4">
                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>

  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      controls: [
        'Community Cloud With IaaS',
        'Private Cloud With IaaS',
        'Community Cloud With PaaS',
        'Private Cloud With PaaS',
        'Public Cloud With PaaS',
        'Community Cloud With SaaS',
        'Private Cloud With SaaS',
        'Public Cloud With SaaS',
        'Hybrid Cloud',
        'Public Cloud With IaaS'
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel()
        }
      }
    },
    markSimulation () {

      let total_score = 0

      if (document.getElementById('input0').textContent === 'Private Cloud With IaaS') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').textContent  === 'Community Cloud With PaaS') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').textContent  === 'Hybrid Cloud') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input3').textContent === 'Public Cloud With SaaS') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input4').textContent === 'Public Cloud With PaaS') {
        document.getElementById('input4').style.borderColor = '#28C76F'
        document.getElementById('input4').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input4').style.borderColor = '#fd4445'
        document.getElementById('input4').style.backgroundColor = '#fd4445'
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism,
    shuffle
  },
  created () {
    this.controls = shuffle(this.controls)
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

